import React from 'react';
import { Chip } from '@mui/material';

interface WorkflowStatusChipProps {
  isActive: boolean;
}

const WorkflowStatusChip: React.FC<WorkflowStatusChipProps> = ({ isActive }) => (
  <Chip
    label={isActive ? 'Active' : 'Inactive'}
    size="small"
    sx={{
      backgroundColor: isActive ? '#dcfce7' : '#f1f5f9',
      color: isActive ? '#166534' : '#64748b',
      fontWeight: 600,
      fontSize: '0.75rem',
      height: '24px',
    }}
  />
);

export default WorkflowStatusChip;
